import * as c from "./constants";

export const setActiveHost = activeHost => ({
  type: c.ACTIVE,
  payload: { activeHost }
});

export const setActiveServer = activeServer => ({
  type: c.ACTIVE,
  payload: { activeServer }
});

export const setActiveOrganization = activeOrganization => ({
  type: c.ACTIVE,
  payload: { activeOrganization }
});

export const setActivePackage = activePackage => ({
  type: c.ACTIVE,
  payload: { activePackage }
});



// WEBPACK FOOTER //
// ./src/actions/activeActions.js